/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class superbillindex extends IceEntity {
  superbill_index_key: string = "";
  superbill_key: string = "";
  name: string = "";
  taxonomy_code: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;

  constructor() {
    super();
  }

  gettablename(): string {
    return "SUPERBILL_INDEX";
  }
}
